<template>
  <div v-if="orderStatus >= -1">
    <b-badge v-if="orderStatus === -1" variant="danger">Rejected</b-badge>
    <b-badge v-if="orderStatus === 0" variant="dark">Pending</b-badge>
    <b-badge v-if="orderStatus === 1" variant="warning">Processing</b-badge>
    <b-badge v-if="orderStatus === 2" variant="primary">Sending</b-badge>
    <b-badge v-if="orderStatus === 3" variant="success">Completed</b-badge>
  </div>
</template>

<script>
export default {
  name: "OrderStatus",
  props: {
    orderStatus: {
      default: 0,
      type: Number
    }
  }
};
</script>

<style>
</style>